import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type IExportAnalyticsModalView } from 'widgets/ExportAnalyticsModal/store/exportAnalyticsModalStore'

type IExportAnalyticsModalActionsProps = {
  store: IExportAnalyticsModalView
}

export const ExportAnalyticsModalActions: FC<IExportAnalyticsModalActionsProps> = observer(
  ({ store: { onExport, disabled, loadingExport } }) => {
    return (
      <Button
        typeBtn={'contained'}
        text={'Export'}
        onClick={onExport}
        disabled={disabled}
        loading={loadingExport}
      />
    )
  }
)
